const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";
const APIHOST_V2 = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api/v2" : "https://www.christmaslistapp.com/api/v2";

function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function searchAmazon(params, token) {
    console.log('SEARCHING FOR AMAZON ITEMS...', params);
    var queryString = Object.keys(params).filter(key=> params[key]).map(key => key + '=' + params[key]).join('&');
    return fetch(APIHOST + "/productsearch?" + queryString, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return err;
        });
}

export function searchGiftIdeas(params, token) {
    console.log('SEARCHING FOR GIFT IDEAS...', params);
    var queryString = Object.keys(params).filter(key=> params[key]).map(key => key + '=' + params[key]).join('&');
    return fetch(APIHOST_V2 + "/giftideas/search?" + queryString, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return err;
        });
}

export function addGiftIdea(data, token) {
    console.log('ADDING GIFT IDEA...', data);
    return fetch(APIHOST_V2 + "/giftideas/add", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return err;
        });
}

export function getGiftIdea(giftIdeaId, token) {
    console.log('GET GIFT IDEA...', giftIdeaId);
    return fetch(APIHOST + "/giftidea/" + giftIdeaId, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return err;
        });
}



